export default function ComingSoonPage() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800;900&display=swap');

        .cinzel-font {
          font-family: 'Cinzel', serif;
        }

        .animate-float {
          animation: float 4s ease-in-out infinite;
        }

        .animate-watch-loader {
          animation: watchRotate 4s linear infinite;
          transform-origin: center;
        }

        .animate-spin-slow {
          animation: spin 12s linear infinite;
        }

        .animate-spin-reverse {
          animation: spinReverse 15s linear infinite;
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-12px);
          }
        }

        @keyframes watchRotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes spinReverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }

        @keyframes drift {
          0%, 100% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(20px, -20px) rotate(90deg);
          }
          50% {
            transform: translate(-10px, -40px) rotate(180deg);
          }
          75% {
            transform: translate(-30px, -20px) rotate(270deg);
          }
        }

        @keyframes floatSlow {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
          }
          50% {
            transform: translateY(-30px) translateX(15px);
          }
        }

        @keyframes pulse-glow {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }

        .animate-drift {
          animation: drift 20s ease-in-out infinite;
        }

        .animate-float-slow {
          animation: floatSlow 8s ease-in-out infinite;
        }

        .animate-pulse-glow {
          animation: pulse-glow 4s ease-in-out infinite;
        }
      `}</style>

      <div className="min-h-screen bg-[#f5efe4] flex items-center justify-center overflow-hidden relative px-6 py-10">
        {/* Background Effects */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-yellow-200/40 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber-300/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute top-1/2 left-1/4 w-64 h-64 bg-orange-200/30 rounded-full blur-3xl animate-pulse-glow"></div>
        <div className="absolute top-1/3 right-1/3 w-80 h-80 bg-yellow-300/20 rounded-full blur-3xl animate-pulse-glow" style={{animationDelay: '2s'}}></div>

        {/* Decorative Dots/Particles */}
        <div className="absolute top-40 right-1/3 w-3 h-3 bg-amber-400/40 rounded-full animate-pulse"></div>
        <div className="absolute bottom-40 left-1/3 w-2 h-2 bg-yellow-500/40 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/4 left-1/2 w-4 h-4 bg-orange-400/30 rounded-full animate-pulse" style={{animationDelay: '2s'}}></div>
        <div className="absolute bottom-1/3 right-1/2 w-3 h-3 bg-amber-500/35 rounded-full animate-pulse" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-2/3 left-1/4 w-2 h-2 bg-yellow-400/40 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-1/3 right-1/4 w-3 h-3 bg-orange-300/35 rounded-full animate-pulse" style={{animationDelay: '2.5s'}}></div>

        {/* Main Content */}
        <div className="relative z-10 max-w-4xl w-full text-center">
          {/* Logo */}
          <div className="flex justify-center mb-10 animate-float">
            <img
              src="/logo.png"
              alt="Horology Institute"
              className="w-48 h-48 md:w-64 md:h-64 object-contain drop-shadow-xl"
            />
          </div>

          {/* Heading */}
          <h1 className="cinzel-font text-5xl md:text-7xl font-black tracking-[8px] text-[#3f2b1d] mb-5 leading-tight">
            COMING SOON
          </h1>

          {/* Badge */}
          <div className="inline-block bg-[#b08d57] text-white px-6 py-3 text-lg shadow-lg mb-6 animate-bounce tracking-wide cinzel-font font-bold">
            UNDER CONSTRUCTION
          </div>

          {/* Institute Name */}
          <h2 className="cinzel-font text-3xl md:text-5xl text-[#6E4E2E] mb-6 leading-tight">
            Horology Institute
          </h2>

          {/* Description */}
          <p className="cinzel-font text-lg md:text-xl text-[#5b4633] max-w-2xl mx-auto leading-relaxed mb-10 px-2">
            Professional e-Learning platform providing educative study materials for self-learning by experts with over 38 years of rich experience in the watch industry.
          </p>

          {/* Watch Loader */}
          <div className="flex flex-col items-center justify-center mb-12">
            <div className="relative w-32 h-32 rounded-full border-[6px] border-[#d8c2a2] bg-white shadow-2xl flex items-center justify-center">
              {/* Rotating Ring */}
              <div className="absolute inset-0 rounded-full border-t-[6px] border-[#b08d57] border-r-[6px] border-r-transparent border-b-[6px] border-b-transparent border-l-[6px] border-l-transparent animate-watch-loader"></div>

              {/* Watch Hands - 10:10 position */}
              {/* Hour hand pointing to 10 (300 degrees from 12 o'clock) */}
              <div className="absolute w-[4px] h-10 bg-[#7a5528] rounded-full origin-bottom bottom-1/2" style={{transform: 'rotate(300deg)'}}></div>
              
              {/* Minute hand pointing to 2 (60 degrees from 12 o'clock, representing 10 minutes) */}
              <div className="absolute w-[3px] h-12 bg-[#c79b5b] rounded-full origin-bottom bottom-1/2" style={{transform: 'rotate(60deg)'}}></div>

              {/* Center Dot */}
              <div className="w-4 h-4 bg-[#7a5528] rounded-full z-10"></div>
            </div>

            <div className="mt-5 text-[#6E4E2E] text-lg tracking-[3px] cinzel-font animate-pulse">
              BUILDING TIME...
            </div>
          </div>

          {/* Footer */}
          <div className="mt-12 text-[#7d654d] tracking-[4px] uppercase text-sm leading-relaxed px-4">
            The Timekeeping Heritage • The Future Of Excellence
          </div>
        </div>
      </div>
    </>
  );
}
